<div class="asset-container">
  <div class="asset-topbar">
    <div class="topbar-left">
      <h1>
        Register Items
        <small>All registered items</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i> <span>Inventory</span> / <span class="current">Register Items</span>
        <span class="separator">|</span>
        <span class="time"><i class="bi bi-clock"></i> {{ timestamp() }}</span>
      </div>
    </div>
    <div class="topbar-right">
      <div class="search-box">
        <i class="bi bi-search"></i>
        <input type="text" placeholder="Search items..." [ngModel]="search()" (ngModelChange)="search.set($event); onSearchChange()" />
      </div>
      <button class="btn btn-outline btn-sm" (click)="exportData()">
        <i class="bi bi-download"></i> Export
      </button>
      <button class="btn btn-primary" (click)="openRegisterModal()">
        <i class="bi bi-plus-circle"></i> Register Item
      </button>
    </div>
  </div>

  <div class="stats-row">
    <div class="stat-card">
      <div class="stat-icon blue">
        <i class="bi bi-box-seam"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Total Items</div>
        <div class="stat-value">{{ stats().total }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon green">
        <i class="bi bi-check-circle"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Active</div>
        <div class="stat-value">{{ stats().active }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon amber">
        <i class="bi bi-clock"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Retired</div>
        <div class="stat-value">{{ stats().retired }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon red">
        <i class="bi bi-tools"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Disposed</div>
        <div class="stat-value">{{ stats().disposed }}</div>
      </div>
    </div>
  </div>

  <div class="filter-bar">
    <div class="filter-left">
      <div class="filter-group">
        <label><i class="bi bi-tags"></i> Category</label>
        <select [ngModel]="categoryFilter()" (ngModelChange)="categoryFilter.set($event); onFilterChange()">
          <option value="all">All Categories</option>
          @for (cat of categories(); track cat.id) {
            <option [value]="cat.name">{{ cat.name }}</option>
          }
        </select>
      </div>
      <div class="filter-group">
        <label><i class="bi bi-check-circle"></i> Status</label>
        <select [ngModel]="statusFilter()" (ngModelChange)="statusFilter.set($event); onFilterChange()">
          <option value="all">All Status</option>
          <option value="active">Active</option>
          <option value="retired">Retired</option>
          <option value="disposed">Disposed</option>
        </select>
      </div>
      <div class="filter-group">
        <label><i class="bi bi-geo-alt"></i> Location</label>
        <select [ngModel]="locationFilter()" (ngModelChange)="locationFilter.set($event); onFilterChange()">
          <option value="all">All Locations</option>
          @for (loc of locations(); track loc.id) {
            <option [value]="loc.name">{{ loc.name }}</option>
          }
        </select>
      </div>
    </div>

  </div>

  <div class="table-wrap">
    <div class="table-scroll">
      <table>
        <thead>
          <tr>
            <th>Item Number</th>
            <th>Item</th>
            <th>Category</th>
            <th>Location</th>
            <th>Condition</th>
            <th>Purchase Value</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (asset of paginatedAssets(); track asset.id) {
            <tr>
              <td><span class="asset-number">{{ asset.assetTag }}</span></td>
              <td>
                <div class="asset-item">
                  <i class="bi bi-box-seam"></i>
                  <span>{{ asset.name }}</span>
                </div>
              </td>
              <td>{{ asset.category }}</td>
              <td>{{ asset.location }}</td>
              <td><span class="condition-badge good">{{ asset.condition }}</span></td>
              <td>{{ formatCurrency(asset.purchaseValue) }}</td>
              <td><span class="status-badge available">{{ statusLabel(asset.status) }}</span></td>
              <td class="actions-cell">
                <div class="row-actions">
                  <button type="button" class="btn-action edit" title="Edit item" (click)="openEditModal(asset)">
                    <i class="bi bi-pencil"></i>
                  </button>
                  <button type="button" class="btn-action delete" title="Delete item" (click)="deleteAsset(asset)">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="pagination-bar">
    <div class="pagination-info">
      Showing <span>{{ paginationStart() }}</span> to <span>{{ paginationEnd() }}</span> of <span>{{ filteredAssets().length }}</span> items
    </div>
    <div class="pagination-controls">
      <button class="btn btn-outline btn-sm" [disabled]="page() === 1" (click)="goToPage(page() - 1)"><i class="bi bi-chevron-left"></i> Previous</button>
      @for (p of pageNumbers(); track p) {
        <button class="btn btn-sm" [class.btn-primary]="page() === p" [class.btn-outline]="page() !== p" (click)="goToPage(p)">{{ p }}</button>
      }
      <button class="btn btn-outline btn-sm" [disabled]="page() === totalPages()" (click)="goToPage(page() + 1)">Next <i class="bi bi-chevron-right"></i></button>
    </div>
  </div>
</div>

<div class="modal-overlay" [class.open]="showRegisterModal()" (click)="closeModalOnBackdrop($event)">
  <div class="modal">
    <div class="modal-header">
      <h2>
        <i class="bi" [class]="isEditing() ? 'bi-pencil' : 'bi-plus-circle'"></i>
        {{ isEditing() ? 'Edit Item' : 'Register New Item' }}
      </h2>
      <button class="close-btn" (click)="closeRegisterModal()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <form (ngSubmit)="registerAsset()">
      <div class="modal-body">
        <div class="form-row">
          <div class="form-group">
            <label>Item Number <span class="required">*</span></label>
            <input type="text" placeholder="e.g., ITM-1003" required [ngModel]="newAsset().assetTag" (ngModelChange)="updateNewAsset('assetTag', $event)" name="assetTag" />
          </div>
          <div class="form-group">
            <label>Item Name <span class="required">*</span></label>
            <input type="text" placeholder="e.g., Epson Projector" required [ngModel]="newAsset().name" (ngModelChange)="updateNewAsset('name', $event)" name="name" />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label>Category <span class="required">*</span></label>
            <select required [ngModel]="newAsset().category" (ngModelChange)="updateNewAsset('category', $event)" name="category">
              <option value="">Select Category</option>
              @for (cat of categories(); track cat.id) {
                <option [value]="cat.name">{{ cat.name }}</option>
              }
            </select>
          </div>
          <div class="form-group">
            <label>Location <span class="required">*</span></label>
            <select required [ngModel]="newAsset().location" (ngModelChange)="updateNewAsset('location', $event)" name="location">
              <option value="">Select Location</option>
              @for (loc of locations(); track loc.id) {
                <option [value]="loc.name">{{ loc.name }}</option>
              }
            </select>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label>Condition <span class="required">*</span></label>
            <select required [ngModel]="newAsset().condition" (ngModelChange)="updateNewAsset('condition', $event)" name="condition">
              <option value="Excellent">Excellent</option>
              <option value="Good">Good</option>
              <option value="Fair">Fair</option>
              <option value="Poor">Poor</option>
            </select>
          </div>
          <div class="form-group">
            <label>Status <span class="required">*</span></label>
            <select required [ngModel]="newAsset().status" (ngModelChange)="updateNewAsset('status', $event)" name="status">
              <option value="active">Active</option>
              <option value="retired">Retired</option>
              <option value="disposed">Disposed</option>
            </select>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label>Purchase Date</label>
            <input type="date" [ngModel]="newAsset().purchaseDate" (ngModelChange)="updateNewAsset('purchaseDate', $event)" name="purchaseDate" />
          </div>
          <div class="form-group">
            <label>Purchase Price</label>
            <input type="number" placeholder="0.00" appDecimalOnly [ngModel]="newAsset().purchaseValue" (ngModelChange)="updateNewAsset('purchaseValue', +$event)" name="purchaseValue" />
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline" (click)="closeRegisterModal()">Cancel</button>
        <button type="submit" class="btn btn-primary">
          <i class="bi bi-check-lg"></i> {{ isEditing() ? 'Save Changes' : 'Register Item' }}
        </button>
      </div>
    </form>
  </div>
</div>

@if (showToast()) {
  <div class="toast-container show">
    <div class="toast success">
      <div class="toast-icon"><i class="bi bi-check-circle-fill"></i></div>
      <div class="toast-content">
        <div class="toast-title">Success!</div>
        <div class="toast-message">{{ toastMessage() }}</div>
      </div>
    </div>
  </div>
}
